import React from 'react';
import Version from '../../package.json';

import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import InfoIcon from '@material-ui/icons/Info';

export default function Copyright() {

    const [open, setOpen] = React.useState(false);

    const content = [
        "Menggunakan form Pemutakhiran PK 2025",
        "Retrieve data awal menggunakan data PK-24",
        "Perubahan data progres",
        "Menggunakan maps untuk menentukan lokasi input data",
        "Penambahan form Profile",
        "Upload surat pernyataan",
        "Penambahan download Kuitansi"
    ]

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const DialogVersion = () => {
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Apa yang baru?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <List>
                                {
                                    content.map((data, key) => {
                                        return <ListItem key={key}>
                                            <ListItemAvatar>
                                                <InfoIcon />
                                            </ListItemAvatar>
                                            <ListItemText>
                                                {data}
                                            </ListItemText>
                                        </ListItem>
                                    })
                                }
                            </List>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }

    return (
        <>
            <Typography variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
                Kementerian Kependudukan dan Pembangunan Keluarga / BKKBN{' '}
                {new Date().getFullYear()}
                <br />
                {/* Versi {Version.version} */}
                <Button onClick={handleClickOpen} align="center" className="btnCopyRight">
                    Versi {Version.version}
                </Button>
            </Typography>


            <DialogVersion />
        </>
    );

}